import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';

// project imports
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { MENU_OPEN } from 'store/actions';
import config from 'config';

// assets

// ==============================|| SIDEBAR MENU LIST ITEMS ||============================== //

function NavItem({ item, level }) {
    const dispatch = useDispatch();
    const customization = useSelector((state) => state.customization);

    const isOpen = customization.isOpen.findIndex((id) => id === item.id) > -1;
    const Icon = item.icon;
    const itemIcon = item?.icon ? (
        <Icon stroke={1.5} size="1.3rem" width="1.3rem" />
    ) : (
        <FiberManualRecordIcon
            sx={{
                width:
                    customization.isOpen.findIndex((id) => id === item?.id) > -1 ? 8 : 6,
                height:
                    customization.isOpen.findIndex((id) => id === item?.id) > -1 ? 8 : 6
            }}
            fontSize={level > 0 ? 'inherit' : 'medium'}
        />
    );

    const itemHandler = (id) => {
        dispatch({ type: MENU_OPEN, id });
    };

    // active menu item on page load
    useEffect(() => {
        const currentIndex = document.location.pathname
            .toString()
            .split('/')
            .findIndex((id) => id === item.id);
        if (currentIndex > -1) {
            dispatch({ type: MENU_OPEN, id: item.id });
        }
        // eslint-disable-next-line
    }, []);

    return (
        <ListItemButton
            component={Link}
            to={`${config.basename}${item.url}`}
            target="_self"
            disabled={item.disabled}
            sx={{
                borderRadius: 0,
                alignItems: 'flex-start',
                backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                py: level > 1 ? 1 : 1.25,
                pl: `${level * 24}px`,

                ...(level > 1 && {
                    color: '#ffffff',

                    '&:hover': {
                        backgroundColor: '#ffffff',
                        color: '#bcbcbc'
                    },

                    '&.Mui-selected': {
                        backgroundColor: '#ffffff',
                        color: '#bcbcbc'
                    }
                })
            }}
            selected={isOpen}
            onClick={() => itemHandler(item.id)}
        >
            <ListItemIcon
                className="sidebar-itemNav"
                sx={{
                    my: 'auto',
                    minWidth: !item?.icon ? 18 : 36,
                    color: level > 1 ? 'inherit' : isOpen ? 'primary.main' : '#ffffff',
                    '& svg': {
                        width: '1.3rem',
                        height: '1.3rem',
                        display: 'block',
                        '& *': {
                            fill: 'currentColor',
                            stroke: 'currentColor'
                        }
                    }
                }}
            >
                {itemIcon}
            </ListItemIcon>
            <ListItemText
                primary={
                    <Typography variant={isOpen ? 'h5' : 'body1'} color="inherit">
                        {item.title}
                    </Typography>
                }
            />
        </ListItemButton>
    );
}

NavItem.propTypes = {
    item: PropTypes.object,
    level: PropTypes.number
};

export default NavItem;
